<template>
  <BgImageLayout title="Imported Publisher/Vendor">
    <AgGridWrapper :options="gridOptions" :include-search-box="true" title="Previous imports" />
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
import gridOptions from './gridOptions'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions],

  data: () => ({
    importedProviders: null
  }),

  created() {
    apiTo.GET_PROVIDERS_IMPORTS().then(({ data }) => (this.importedProviders = data.result))
  }
}
</script>
